module.exports = __webpack_public_path__ + "img/D630849B-CCA2-4859-9B2B-AE3D9BF40A32.1f45af06.jpg";